import { render, staticRenderFns } from "./StarsWrapper.vue?vue&type=template&id=04a358f7&scoped=true"
import script from "./StarsWrapper.vue?vue&type=script&lang=js"
export * from "./StarsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a358f7",
  null
  
)

export default component.exports